import {LoadingBox} from 'letrus-ui';
import styles from './LoadingRecommendation.module.scss';

function LoadingRecommendation() {
  return (
    <article className={styles.recommendation}>
      <div className={styles.recommendationHeader}>
        <h3 className={styles.recommendationTitle}>
          <LoadingBox width="15rem" height="1.5rem" borderRadius={5} />
          <LoadingBox width="3.5rem" height="1.5rem" borderRadius={5} />
        </h3>
      </div>

      <LoadingBox width="10rem" height="2.5rem" borderRadius={25} />
    </article>
  );
}

export default LoadingRecommendation;
